import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type ZencargoNetworkQueryVariables = GraphQLTypes.Exact<{ [key: string]: never }>;

export type ZencargoNetworkQueryResult = { __typename?: 'Query' } & {
  zencargoNetwork?: GraphQLTypes.Maybe<{ __typename?: 'Network' } & Pick<GraphQLTypes.Network, 'id'>>;
};

export const ZencargoNetworkQueryDocument = gql`
  query zencargoNetworkQuery {
    zencargoNetwork {
      id
    }
  }
`;
